<template>
    <v-container>
        <tryout-form></tryout-form>

        <question-importer></question-importer>

        <tryout-question></tryout-question>

        <div class="text-right mt-4">
            <v-btn
                @click="update"
                rounded
                color="primary"
                :loading="$store.get('loader/loading', 'updating')"
            >
                Edit
            </v-btn>
        </div>
    </v-container>
</template>

<script>
import TryoutForm from './TryoutForm'
import QuestionImporter from './QuestionImporter'
import TryoutQuestion from './TryoutQuestion'
import parseFromServer from '@/plugins/moment'

export default {
    components: {
        TryoutForm,
        QuestionImporter,
        TryoutQuestion,
    },

    methods: {
        update() {
            this.$api.put(`tryout/${this.$route.params.hash}`, {
                period_id: this.$route.params.period_id,
                ...this.$store.get('createtryout/formInput')
            }, { loader: 'updating' })
                .then(response => {
                    if (response.data.updated) {
                        this.$store.dispatch('flash/info', 'Tryout diedit')
                        this.$router.push({ name: 'period.detail', params: { period_id: this.$route.params.period_id } })
                    } else {
                        this.$store.dispatch('flash/genericError')
                    }
                })
        }
    },

    created() {
        this.$api.get(`tryout/${this.$route.params.hash}`, { loader: 'appbar' })
            .then(response => {
                const tryout = response.data
                const released_at = parseFromServer(tryout.released_at)

                this.$store.set('ui/title', tryout.title)

                this.$store.set('createtryout/input@title', tryout.title)
                this.$store.set('createtryout/input@minute_limit', tryout.minute_limit)
                this.$store.set('createtryout/input@released_date', released_at.format('YYYY-MM-DD'))
                this.$store.set('createtryout/input@released_time', released_at.format('HH:mm'))
                this.$store.set('createtryout/input@questionRandomized', tryout.is_question_randomized)
            })

        this.$api.get(`tryout/${this.$route.params.hash}/question`, { loader: 'appbar' })
            .then(response => {
                this.$store.set('createtryout/questions', response.data.questions)
            })
    },

    destroyed() {
        this.$store.commit('createtryout/RESET')
    }
}
</script>
